import { CircleLoader, Strong, Tag } from '@driftt/tide-core'
import { Icon } from '@driftt/tide-icons'
import classnames from 'classnames'
import React from 'react'

import './styles.css'

const DropdownTrigger = ({ isPlaybookEnabled, isSaving }) => {
  const className = classnames(
    'playbook-version-select-dropdown-trigger',
    isPlaybookEnabled &&
      'playbook-version-select-dropdown-trigger--playbook-enabled'
  )

  return (
    <div className={className}>
      <Tag
        wrapperClass="playbook-version-select-dropdown-trigger-tag-wrapper"
        textClass="playbook-version-select-dropdown-trigger-tag-text"
        text={<Strong>PLAYBOOK IS {isPlaybookEnabled ? 'ON' : 'OFF'}</Strong>}
      />
      {isSaving ? (
        <CircleLoader size="small" />
      ) : (
        <Icon name="chevron-down" width="10" height="5" />
      )}
    </div>
  )
}

export default DropdownTrigger
